export const Token = () => {
  let token = null;
  const getToken = () => {
    const key = localStorage.getItem('key');
    if (!key) return null;

    const item = JSON.parse(key);
    const now = new Date().toISOString();

    if (now > item.expiry) {
      console.log(now, item.expiry)
      localStorage.removeItem('key');
      window.location.pathname = '/login'
      return null
    }
    const userToken = item.token;
    token = userToken;
    return token
  };
  
  getToken();

  const storeToken = userToken => {
    let now = new Date();
    now.setMinutes(now.getMinutes() + 30); // timestamp
    now = new Date(now);

    const item = {
      token: userToken,
      expiry: now
    };
    localStorage.setItem('key', JSON.stringify(item));
    token = userToken;
  };

  return {
    setToken: storeToken,
    token,
    getToken,
  }
}
